import React from "react";
import "./style.css";

const Star5 = () => {
  return (
    <div className="star_container">
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
    </div>
  );
};

export default Star5;
